import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { EmployeesServiceProvider } from '../../api/employees'

const EmployeesService = EmployeesServiceProvider()
const name = 'deleteEmployeeList'

export default (employeeList) => (asyncAction(
  name,
  EmployeesService.deleteEmployeeList,
  { employeeList }
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/employee/deleteEmployeeList.js